import { StyleSheet, Platform } from 'react-native'
import type { Theme } from '../../../src/theme/getTheme'

export const getCreateCalendarHeaderStyles = (_theme: Theme) => StyleSheet.create({
  container: {
    width: '100%',
    zIndex: 1000,
    elevation: 10,
    backgroundColor: 'transparent',
    paddingHorizontal: 14,
    paddingTop: 2,
    paddingBottom: 0,
    // No web header-clearance here: inside the Build step, `contentContainerBuild` already adds
    // paddingTop:60. A local marginTop:60 double-stacked and left an empty band between the
    // One-at-a-time/All-games toggle and the date strip (spec #5). The first-paint skeleton keeps
    // its own clearance via `fixedCalendarContainer` (it sits directly under the fixed PageHeader).
  },
  calendarWrapper: {
    width: '100%',
    alignItems: 'center',
  },
  monthRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    paddingVertical: 3,
    paddingHorizontal: 4,
    marginBottom: 4,
    alignSelf: 'flex-start',
  },
  monthLabel: {
    fontSize: 13,
    fontWeight: '700' as const,
    color: _theme.black,
  },
  calendarHint: {
    marginTop: 6,
    marginHorizontal: 12,
    fontSize: 11,
    color: '#6B7280',
    textAlign: 'center',
  },
  fixedCalendarContainer: {
    width: '100%',
    zIndex: 1000,
    elevation: 10,
    backgroundColor: 'transparent',
    ...(Platform.OS === 'web' && { marginTop: 60 }),
  },
})
